import { Button as KendoButton, ButtonProps as KendoButtonProps} from '@progress/kendo-react-buttons';
import { classNames } from '@progress/kendo-react-common';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { useSvgIcon } from 'components';
import styles from './Button.module.scss';

export type ButtonProps = {
    iconDefinition?: IconDefinition,
    iconPosition?: 'left' | 'right'
} & KendoButtonProps;

export const Button = ({ iconDefinition, iconPosition, className,...rest }: ButtonProps) => {
    const svgIcon = useSvgIcon(iconDefinition);
    const iconClass = iconDefinition ? 'svg-inline--fa fa-1x' : undefined;
    const internalClassName = classNames({
        [styles.icon]: iconDefinition,
        [styles.reverse]: iconPosition === 'right'
    });
    return (
        <KendoButton className={classNames(internalClassName, className)} iconClass={iconClass} svgIcon={svgIcon} role='button' tabIndex={0} aria-hidden="false" {...rest} />
    );
};